import './UsersDialog.css';
import React, { useEffect } from 'react';
import { withTranslate } from 'react-redux-multilingual';
import PasswordStrengthBar from 'react-password-strength-bar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import OutlinedInput from '@mui/material/OutlinedInput';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';

import {
    ValidateEmail,
    ValidatePassword,
} from '../../../libraries/Tool';

import { 
    GetCompanies,
} from '../../../services/Users.service';

function UsersDialog(props) {
    const { translate, open, data, handleClose, handleAgree } = props;
    const [isError, setIsError] = React.useState(false);
    const [userID, setUserID] = React.useState();
    const [email, setEmail] = React.useState();
    const [emailInvalid, setEmailInvalid] = React.useState(false);
    const [firstName, setFirstName] = React.useState();
    const [lastName, setLastName] = React.useState();
    const [endDate, setEndDate] = React.useState();
    const [password, setPassword] = React.useState();
    const [showPassword, setShowPassword] = React.useState(false);
    const [passwordInvalid, setPasswordInvalid] = React.useState(false);
    const [roleID, setRoleID] = React.useState();
    const [planID, setPlanID] = React.useState();
    const [locale, setLocale] = React.useState("en");
    const [companyCategory, setCompanyCategory] = React.useState(1);
    const [companyName, setCompanyName] = React.useState();
    const [companyID, setCompanyID] = React.useState();
    const [telNumber, setTelNumber] = React.useState();
    const [companies, setCompanies] = React.useState([]);
    const [remarks, setRemarks] = React.useState();

    const handleClickAgree = () => {
        setIsError(false);
        if(
            !email ||
            emailInvalid || 
            !firstName ||
            !lastName ||
            (
                userID && 
                !endDate &&
                planID !== 2
            ) ||
            (
                !userID && 
                (
                    !password || 
                    passwordInvalid
                )
            ) ||
            (
                !userID && 
                !locale
            ) ||
            !roleID ||
            !String(planID) ||
            (
                planID === 2 && 
                (
                    (companyCategory === 1 && 
                        (
                            !companyName || 
                            !telNumber
                        )
                    ) || 
                    (
                        companyCategory === 2 && 
                        !companyID
                    )
                )
            )
        ) {
            setIsError(true);
            return;
        }
        handleAgree({
            email
            ,firstName
            ,lastName
            ,endDate
            ,password
            ,roleID
            ,planID
            ,locale
            ,companyCategory
            ,companyName
            ,companyID
            ,telNumber
            ,userID
            ,remarks
        });
    }

    useEffect(() => {
        GetCompanies()
        .then(res => {
            // console.log(res)
            setCompanies(res.data.datas);
        })
    }, [])

    useEffect(() => {
        setIsError(false);
        setUserID(data?.userID);
        setEmail(data?.email);
        setFirstName(data?.firstName);
        setLastName(data?.lastName);
        setEndDate(data?.endDate || null);
        setPassword(data?.password);
        setRoleID(data?.roleID || 2);
        setPlanID(data?.planID || 0);
        setCompanyName(data?.companyName);
        setCompanyID(data?.companyID);
        setTelNumber(data?.telNumber);
        setRemarks(data?.remarks);
    }, [open])

    return (
    <div>
      <Dialog
        fullWidth
        maxWidth="sm"
        open={open}
        onClose={handleClose}
      >
        <DialogTitle>
          {data?.userID ? translate('edituser') : translate('addnewuser')}
        </DialogTitle>
        <DialogContent dividers>
            <Grid container spacing={2}>
                <Grid item xs={6}>
                    <FormControl fullWidth required className='users-dialog'>
                        <Typography fontSize="inherit" component="label">{translate('role')}</Typography>
                        <Select
                            id="role"
                            size='small'
                            value={roleID || ""}
                            error={!roleID && isError}
                            onChange={(e) => setRoleID(e.target.value)}
                        >
                            <MenuItem value={1}>{translate('administrator')}</MenuItem>
                            <MenuItem value={2}>{translate('user')}</MenuItem>
                        </Select>
                        {!roleID && isError &&
                            <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>
                </Grid>
                <Grid item xs={6}>
                    <FormControl fullWidth required className='users-dialog'>
                        <Typography fontSize="inherit" component="label">{translate('package')}</Typography>
                        <Select
                            id="plan"
                            size='small'
                            value={planID?.toString() || ""}
                            error={(planID === "" || planID === undefined) && isError}
                            onChange={(e) => setPlanID(parseInt(e.target.value))}
                        >
                            <MenuItem value={0}>{translate('standard')}</MenuItem>
                            <MenuItem value={1}>{translate('premium')}</MenuItem>
                            <MenuItem value={2}>{translate('enterprise')}</MenuItem>
                        </Select>
                        {(planID === "" || planID === undefined) && isError &&
                            <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>
                </Grid>
                {planID === 2 &&
                <>
                    {!userID &&
                    <Grid item xs={12}>
                        <FormControl fullWidth required className='users-dialog'>
                            <FormLabel>{translate('companycategory')}</FormLabel>
                            <RadioGroup
                                row
                                name="companyCategory"
                                value={companyCategory}
                                onChange={(e) => {
                                    setCompanyCategory(parseInt(e.target.value));
                                    setCompanyName("");
                                    setCompanyID("");
                                    setTelNumber("");
                                }}
                            >
                                <FormControlLabel value={1} control={<Radio />} label={translate('new')} />
                                <FormControlLabel value={2} control={<Radio />} label={translate('existing')} />
                            </RadioGroup>
                            {!locale && isError &&
                                <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                            }
                        </FormControl>
                    </Grid>}
                    {!userID && (companyCategory === 1) &&
                    <Grid item xs={6}>
                        <FormControl fullWidth required className='users-dialog'>
                            <Typography fontSize="inherit" component="label">{translate('companyname')}</Typography>
                            <OutlinedInput
                                id="companyName"
                                size='small' 
                                placeholder=""
                                value={companyName}
                                error={(!companyName) && isError}
                                disabled={userID}
                                onChange={(e) => {
                                    setCompanyName(e.target.value);
                                }}
                            />
                            {(!companyName) && isError &&
                                <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                            }
                        </FormControl>
                    </Grid>}
                    {(userID || (companyCategory === 2)) &&
                    <Grid item xs={6}>
                        <FormControl fullWidth required className='users-dialog'>
                            <Typography fontSize="inherit" component="label">{translate('companyname')}</Typography>
                            <Autocomplete
                                fullWidth
                                size="small"
                                options={companies}
                                defaultValue={companies?.find(item => item.companyID === companyID)}
                                getOptionLabel={(option) => option.companyName}
                                renderInput={(params) => <TextField {...params} />}
                                error={(!companyName || !companyID) && isError}
                                onChange={(event, newValue) => {
                                    setCompanyID(newValue?.companyID || "");
                                    setCompanyName(newValue?.companyName || "");
                                    setTelNumber(newValue?.telNumber || "");
                                }}
                            />
                        </FormControl>
                    </Grid>}
                    <Grid item xs={6}>
                        <FormControl fullWidth required className='users-dialog'>
                            <Typography fontSize="inherit" component="label">{translate('telnumber')}</Typography>
                            <OutlinedInput
                                id="telNumber"
                                size='small' 
                                placeholder=""
                                value={telNumber}
                                error={(!telNumber) && isError}
                                disabled={userID || companyCategory === 2}
                                onChange={(e) => {
                                    setTelNumber(e.target.value);
                                }}
                            />
                            {(!telNumber) && isError &&
                                <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                            }
                        </FormControl>
                    </Grid>
                </>
                }
                <Grid item xs={12}>
                    <FormControl fullWidth required className='users-dialog'>
                        <Typography fontSize="inherit" component="label">{translate('email')}</Typography>
                        <OutlinedInput
                            id="email"
                            size='small' 
                            placeholder=""
                            value={email}
                            error={(!email || emailInvalid) && isError}
                            disabled={userID}
                            onChange={(e) => {
                                setEmail(e.target.value);
                                setEmailInvalid(!ValidateEmail(e.target.value));
                            }}
                        />
                        {(!email || emailInvalid) && isError &&
                            <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>
                </Grid>
                <Grid item xs={6}>
                    <FormControl fullWidth required className='users-dialog'>
                        <Typography fontSize="inherit" component="label">{translate('firstname')}</Typography>
                        <OutlinedInput
                            id="firstName"
                            size='small' 
                            placeholder=""
                            value={firstName}
                            error={!firstName && isError}
                            onChange={(e) => setFirstName(e.target.value)}
                        />
                        {!firstName && isError &&
                            <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>
                </Grid>
                <Grid item xs={6}>
                    <FormControl fullWidth required className='users-dialog'>
                        <Typography fontSize="inherit" component="label">{translate('lastname')}</Typography>
                        <OutlinedInput
                            id="lastName"
                            size='small' 
                            placeholder=""
                            value={lastName}
                            error={!lastName && isError}
                            onChange={(e) => setLastName(e.target.value)}
                        />
                        {!lastName && isError &&
                            <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>
                </Grid>
                {userID &&
                planID !== 2 &&
                <Grid item xs={6}>
                     <FormControl fullWidth required className='users-dialog'>
                         <Typography fontSize="inherit" component="label">{translate('expiration')}</Typography>
                         <OutlinedInput
                            id="endDate"
                            size='small'
                            type='date'
                            placeholder=""
                            value={endDate}
                            error={!endDate && isError}
                            onChange={(e) => setEndDate(e.target.value || null)}
                         />
                         {!endDate && isError &&
                             <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                         }
                     </FormControl>
                 </Grid>
                }
                {!userID &&
                <Grid item xs={12}>
                    <FormControl fullWidth required className='users-dialog'>
                        <Typography fontSize="inherit" component="label">{translate('password')}</Typography>
                        <OutlinedInput
                            id="password"
                            type={showPassword ? 'text' : 'password'}
                            value={password}
                            error={(!password || passwordInvalid) && isError}
                            onChange={(e) => {
                                setPassword(e.target.value);
                                setPasswordInvalid(!ValidatePassword(e.target.value));
                            }}
                            size='small'
                            endAdornment={
                            <InputAdornment position="end">
                                <IconButton
                                    onClick={() => {setShowPassword(!showPassword)} }
                                    onMouseDown={(event) =>  event.preventDefault() }
                                    edge="end"
                                    size='small'
                                >
                                {showPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                            </InputAdornment>
                            }
                        />
                        {(!password || passwordInvalid) && isError &&
                            <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>
                    <PasswordStrengthBar 
                        password={password}
                        scoreWords={[translate('weak'), translate('okay'), translate('good'), ('strong'), translate('stronger')]}
                        minLength={8}
                        shortScoreWord={(password || password === "") ? translate('tooshort') : ''}
                    />
                </Grid>}
                <Grid item xs={12}>
                    <FormControl fullWidth required className='users-dialog'>
                        <Typography fontSize="inherit" component="label">{translate('remarks')}</Typography>
                        <OutlinedInput
                            id="remarks"
                            size='small'
                            type='text'
                            multiline
                            maxRows={4}
                            placeholder=""
                            value={remarks}
                            onChange={(e) => setRemarks(e.target.value)}
                        />
                     </FormControl>
                </Grid>
                {!userID &&
                <Grid item xs={12}>
                    <FormControl fullWidth required className='users-dialog'>
                        <FormLabel>{translate('languageofverifyemail')}</FormLabel>
                        <RadioGroup
                            row
                            name="locale"
                            value={locale}
                            onChange={(e) => setLocale(e.target.value)}
                        >
                            <FormControlLabel value="en" control={<Radio />} label={translate('english')} />
                            <FormControlLabel value="vi" control={<Radio />} label={translate('vietnamese')} />
                            <FormControlLabel value="ja" control={<Radio />} label={translate('japanese')} />
                        </RadioGroup>
                        {!locale && isError &&
                            <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>
                </Grid>}
            </Grid>
        </DialogContent>
        <DialogActions>
            <Button variant="contained" size="small" disableElevation color='secondary' onClick={handleClose}>
            {translate('cancel')}
            </Button>
            <Button variant="contained" size="small" disableElevation color="info" onClick={handleClickAgree}>
            {translate('ok')}
            </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
export default withTranslate(UsersDialog);